import { TemplateState, KeyPath } from '../templateeditor/templateeditor-types';
import { DisplayType } from './constants';

export const CheckboxAspectRatio = 1.0;

export function setDefaultCheckboxDisplayType(
  state: TemplateState,
  fieldPositionKeyPaths: KeyPath[],
  setIn: <T, TValue>(obj: T, keyPath: KeyPath, value: TValue) => void
) {
  for (const fieldPositionKeyPath of fieldPositionKeyPaths) {
    setIn(state, [...fieldPositionKeyPath, 'displayType'], DisplayType.Xmark);
  }
}
